import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SessionManagementApiService } from '../../../../../../../services/api/session-management-api.service';
import { CampsDetailsFormStateService } from '../../../../camp-details-form-state-service';
import { BayclubsAlertService } from '@bayclubs/alert';
import { ErrorTranslationService } from '@bayclubs/utils';
import { camps } from '../../../../../../../models/models.generated';

@Component({
    selector: 'app-session-days-shift',
    templateUrl: './session-days-shift.component.html',
    styleUrls: ['./session-days-shift.component.scss'],
    standalone: false
})
export class SessionDaysShiftComponent implements OnInit {
    @Input() public form: UntypedFormGroup;

    public postponePending: boolean = false;

    public numberOfDays: number = 7;

    constructor(private api: SessionManagementApiService,
        public state: CampsDetailsFormStateService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService) {

    }

    get sessionId(): string {
        return this.form.controls.id.value;
    }

    ngOnInit(): void {
    }

    onPostponeSessionClicked() : void {
        this.postponePending = !this.postponePending;
    }

    postpone(): void{
        const request = <camps.SessionMoveDaysRequest>{
            daysToMove: this.numberOfDays,
            sessionId: this.sessionId
        };

        this.api.shiftSession(request).subscribe(x => {
            if (x.isSuccess) {
                this.alert.showOperationSuccess();
                this.postponePending = false;
                this.state.sessionChanged.emit(this.sessionId);
            } else {
                this.errorTranslate.translateValidationNotifications(x.validationNotification);
                this.alert.showError(x.validationNotification.errors[0].message);
            }
        });
    }
}
